import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ID, Response, SERVICIOS_API } from '../../../../../../_metronic/helpers'
import { Producto, UsersQueryResponse } from './_models'
import { getAuth } from '../../../../auth'

const API_URL = process.env.REACT_APP_API_URL
const PRODUCTOS_URL = API_URL + SERVICIOS_API.URL_PRODUCTOS

const usuario = getAuth();
const config: AxiosRequestConfig = {
  headers: {
    'x-token': `${usuario?.api_token}`,
  },
};
const getProductos = (query: string): Promise<UsersQueryResponse> => {
  return axios
    .get(`${PRODUCTOS_URL}?${query}`, config)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getProductoPorId = (id: ID): Promise<Producto | undefined> => {
  return axios
    .get(`${PRODUCTOS_URL}/${id}`, config)
    .then((response: AxiosResponse<Response<Producto>>) => response.data)
    .then((response: Response<Producto>) => response.data)
}

const createProducto = (user: Producto): Promise<Producto | undefined> => {
  return axios
    .put(PRODUCTOS_URL, user, config)
    .then((response: AxiosResponse<Response<Producto>>) => response.data)
    .then((response: Response<Producto>) => response.data)
}

const updateProducto = (user: Producto): Promise<Producto | undefined> => {
  return axios
    .post(`${PRODUCTOS_URL}/${user.id}`, user, config)
    .then((response: AxiosResponse<Response<Producto>>) => response.data)
    .then((response: Response<Producto>) => response.data)
}

const deleteProducto = (userId: ID): Promise<void> => {
  const config: AxiosRequestConfig = {
    headers: {
      'x-token': `${usuario?.api_token}`,
    },
  };
  return axios.put(`${PRODUCTOS_URL}/eliminar/${userId}`, '', config).then(() => { })
}

const deleteSelectedProductos = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.put(`${PRODUCTOS_URL}/eliminar/${id}`, '', config))
  return axios.all(requests).then(() => { })
}

export { getProductos, deleteProducto, deleteSelectedProductos, getProductoPorId, createProducto, updateProducto }
